import ApiSignals, { ApiSignalFetchers } from "@/apis/api_signals"
import { computed } from "@preact/signals"
import { createLogger } from "@/utils/logger"
const logger = createLogger("BlindBox")

async function fetchBlindBoxDetail(param: BlindBoxApiTypes.Fetcher.Query.Params) {
    await ApiSignalFetchers.fetchDataSignalBlindBox(param)
}
const blindBoxDetail = computed(() => {
    return ApiSignals.dataSignalBlindBox?.value ?? {}
})

async function fetchBlindBoxClaim(data: BlindBoxApiTypes.Claim.Params) {
    await ApiSignalFetchers.fetchDataBlindBoxClaim(data)
}

export { fetchBlindBoxDetail, blindBoxDetail, fetchBlindBoxClaim }